import { render } from "./TheCalendar.vue?vue&type=template&id=063f57c0&lang=pug"
import script from "./TheCalendar.vue?vue&type=script&lang=js"
export * from "./TheCalendar.vue?vue&type=script&lang=js"

import "./TheCalendar.vue?vue&type=style&index=0&id=063f57c0&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__